// v1.1.0 · Qué construimos: índice de capacidades agrupado (lista, no tarjetas)
// v1.3.0 · Catálogo en cuatro columnas, una por familia de sistemas
import React from 'react';
import { capabilities } from '../../data/site';

export default function SiteCapabilities() {
  return (
    <section id="construimos" data-scan className="seam scroll-mt-24 bg-[var(--sheet)] py-20 lg:py-28">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
        <div data-reveal className="grid gap-6 lg:grid-cols-[1fr_1fr] lg:items-end">
          <h2 className="display text-[2.8rem] sm:text-[3.6rem]">Qué construimos</h2>
          <p className="measure text-[1.0625rem] leading-[1.65] text-[var(--ink-2)]">
            Software que reemplaza hojas de cálculo, grupos de WhatsApp y procesos en papel. Lo diseñamos con tu equipo,
            lo construimos y lo dejamos funcionando en producción.
          </p>
        </div>

        <div className="mt-14 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {capabilities.map((g, gi) => (
            <div key={g.group} data-reveal style={{ '--rd': `${gi * 110}ms` }} className="border-t-2 border-[var(--ink)] pt-5">
              <h3 className="display-2 text-[1.6rem]">{g.group}</h3>
              <p className="mt-1.5 text-[14px] text-[var(--ink-2)]">{g.lead}</p>
              <dl className="mt-6 space-y-5">
                {g.items.map((it) => (
                  <div key={it.name}>
                    <dt className="text-[16px] font-semibold">{it.name}</dt>
                    <dd className="mt-1 text-[15px] leading-[1.55] text-[var(--ink-2)]">{it.text}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
